import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { toast } from "sonner";
import { Upload, Trash2 } from "lucide-react";

export default function AdminTeams() {
  const [teams, setTeams] = useState([]);
  const [form, setForm] = useState({ name: "", short_name: "", color: "#39FF14", purse: 10000000, owner: "", logo_file_id: "" });
  const load = async () => setTeams((await api.get("/teams")).data);
  useEffect(() => { load(); }, []);
  const create = async () => {
    if (!form.name) return toast.error("Name required");
    try { await api.post("/admin/teams", form); toast.success("Team created"); setForm({...form, name: "", short_name: "", logo_file_id: ""}); load(); }
    catch { toast.error("Failed"); }
  };
  const upload = async (file) => {
    const fd = new FormData(); fd.append("file", file); fd.append("folder", "team_logos");
    try { const r = await api.post("/files/upload", fd, { headers: {"Content-Type":"multipart/form-data"}}); setForm({...form, logo_file_id: r.data.file_id}); toast.success("Logo uploaded"); }
    catch { toast.error("Upload failed"); }
  };
  const del = async (id) => { if (!confirm("Delete team?")) return; await api.delete(`/admin/teams/${id}`); load(); };
  return (
    <div>
      <div className="text-xs uppercase tracking-[0.4em] text-[#39FF14]">Franchise Teams</div>
      <h1 className="font-display text-4xl mt-2">Teams</h1>
      <div className="mt-6 p-6 bg-[#0B132B] border border-white/10 rounded grid md:grid-cols-6 gap-3">
        <input placeholder="Team Name" value={form.name} onChange={(e)=>setForm({...form, name: e.target.value})} className="bg-black/50 border border-white/15 px-3 py-2 text-sm md:col-span-2" data-testid="team-name"/>
        <input placeholder="Short Name" value={form.short_name} onChange={(e)=>setForm({...form, short_name: e.target.value})} className="bg-black/50 border border-white/15 px-3 py-2 text-sm" data-testid="team-short"/>
        <input placeholder="Owner" value={form.owner} onChange={(e)=>setForm({...form, owner: e.target.value})} className="bg-black/50 border border-white/15 px-3 py-2 text-sm" />
        <input type="number" placeholder="Purse ₹" value={form.purse} onChange={(e)=>setForm({...form, purse: +e.target.value})} className="bg-black/50 border border-white/15 px-3 py-2 text-sm" data-testid="team-purse"/>
        <label className="flex items-center gap-2 border border-dashed border-white/15 px-3 py-2 cursor-pointer text-xs">
          <Upload size={14} className="text-[#39FF14]" /> {form.logo_file_id ? "Uploaded ✓" : "Logo"}
          <input type="file" accept="image/*" className="hidden" onChange={(e)=>upload(e.target.files?.[0])}/>
        </label>
        <input type="color" value={form.color} onChange={(e)=>setForm({...form, color: e.target.value})} className="w-full h-10 bg-black/50"/>
        <button onClick={create} data-testid="create-team" className="md:col-span-6 py-2 bg-[#39FF14] text-black font-bold uppercase tracking-widest text-xs">Create Team</button>
      </div>
      <div className="mt-6 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {teams.map((t) => (
          <div key={t.id} className="p-5 bg-[#0B132B] border border-white/10 rounded" style={{borderLeftColor: t.color, borderLeftWidth: 4}}>
            <div className="flex items-center gap-3">
              {t.logo_file_id ? <img src={fileUrl(t.logo_file_id)} className="w-12 h-12 object-contain bg-white/10"/> : <div className="w-12 h-12 grid place-items-center bg-white/10 font-display" style={{color: t.color}}>{t.short_name || t.name[0]}</div>}
              <div className="flex-1">
                <div className="font-display text-xl">{t.name}</div>
                <div className="text-xs text-white/50">{t.owner || "No owner"}</div>
              </div>
              <button onClick={()=>del(t.id)} className="text-[#FF2442] hover:bg-white/5 p-2"><Trash2 size={14}/></button>
            </div>
            <div className="mt-3 flex justify-between text-xs">
              <div><div className="text-white/50 uppercase tracking-widest">Purse</div><div className="text-[#FFD700] font-display text-lg">₹{(t.purse/100000).toFixed(1)}L</div></div>
              <div><div className="text-white/50 uppercase tracking-widest">Spent</div><div className="text-[#39FF14] font-display text-lg">₹{((t.spent||0)/100000).toFixed(1)}L</div></div>
              <div><div className="text-white/50 uppercase tracking-widest">Players</div><div className="font-display text-lg">{(t.players||[]).length}</div></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
